import React, {Fragment} from 'react';
import {GOOGLE_MAPS_KEY, SCHEMA_LIST, SCHEMA_MAP} from "../Const";
import {LoadScript} from '@react-google-maps/api';
import MapView from "./MapView";
import AbstractMode from "./AbstractMode";
import ListView from "./ListView";
import MemberDetail from "../components/MemberDetail";
import FilterMobile from "../components/FilterMobile";
import CategoryLegend from "../components/CategoryLegend";
import {changeUrl, changeUrlForMember} from "../service/Url";

// Static libraries array to prevent re-rendering  
const GOOGLE_MAPS_LIBRARIES = ['places'];

class Mobile extends AbstractMode {

    constructor(props, state) {
        super(props);

    }

    handleSchemaChange = (event, schema) => {
        event.preventDefault();
        this.setState({
            schema: schema
        })
    }

    render() {

        const {
            categories,
            members,
            mapProps,
            onSelectCategory,
            onSelectPlace,
            onSliderChange,
            onSliderChangeComplete,
            handleGeoPosition,
            removeGeoPosition,
            onChangeSort,
            filter
        } = this.props;

        const overrideMapProps = {
            ...mapProps,
            height: 'calc(100vh - 62px)'
        };

        return (
            <Fragment>

                <LoadScript googleMapsApiKey={GOOGLE_MAPS_KEY} libraries={GOOGLE_MAPS_LIBRARIES}>
                    <div className="viewmode-mobile">


                        {
                            (this.state.selectedMarker.key !== null)
                                ?
                                <Fragment>
                                    <MemberDetail
                                        member={this.state.selectedMarker.member}
                                        categories={categories}
                                        selected={this.state.selectedMarker.key}
                                        total={members.length}
                                        onClose={() => {
                                            changeUrl(this.props.application.url);
                                            this.setState({
                                                selectedMarker: {
                                                    key: null,
                                                    member: {},
                                                }
                                            })
                                        }}
                                        onPrev={() => {

                                            let newKey = this.state.selectedMarker.key - 1;
                                            if (newKey < 0) {
                                                newKey = (members.length - 1);
                                            }

                                            changeUrlForMember(members[newKey]);

                                            this.setState({
                                                selectedMarker: {
                                                    key: newKey,
                                                    member: members[newKey],
                                                }
                                            })
                                        }}
                                        onNext={() => {

                                            let newKey = this.state.selectedMarker.key + 1;
                                            if (newKey > (members.length - 1)) {
                                                newKey = 0;
                                            }

                                            changeUrlForMember(members[newKey]);

                                            this.setState({
                                                selectedMarker: {
                                                    key: newKey,
                                                    member: members[newKey],
                                                }
                                            })
                                        }}
                                    />
                                </Fragment>
                                :
                                <Fragment>
                                    {
                                        (this.state.schema === SCHEMA_MAP)
                                            ?
                                            <div className="mobile-map-wrapper">
                                                <div className="mobile-map">
                                                    {
                                                        <MapView
                                                            key="map-view-stable"
                                                            categories={categories}
                                                            members={members}
                                                            mapProps={overrideMapProps}
                                                            filter={filter}
                                                            onMarkerClick={(event, member, index) => {
                                                                changeUrlForMember(member);
                                                                this.setState({
                                                                    selectedMarker: {
                                                                        key: index,
                                                                        index,
                                                                        member
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    }

                                                    <div className="mobile-buttons">
                                                        <button
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    isFilterOpen: false
                                                                }, () => {
                                                                    this.handleSchemaChange(e, SCHEMA_LIST);
                                                                })
                                                            }}
                                                        ><i className="fas fa-bars" />
                                                        </button>
                                                        <button
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    isFilterOpen: true
                                                                }, () => {
                                                                    this.handleSchemaChange(e, SCHEMA_LIST);
                                                                })
                                                            }}
                                                        ><i className="fas fa-search" />
                                                        </button>
                                                    </div>

                                                </div>
                                                <CategoryLegend
                                                    categories={categories}
                                                />
                                            </div>
                                            :
                                            <div className="mobile-filter">
                                                <FilterMobile
                                                    open={this.state.isFilterOpen}
                                                    onSliderChange={onSliderChange}
                                                    onSliderChangeComplete={onSliderChangeComplete}
                                                    filter={filter}
                                                    categories={categories}
                                                    members={members}
                                                    onSelectCategory={onSelectCategory}
                                                    onSelectPlace={onSelectPlace}
                                                    schema={this.state.schema}
                                                    onFilterChange={this.onFilterChange}
                                                    handleGeoPosition={handleGeoPosition}
                                                    removeGeoPosition={removeGeoPosition}
                                                    onChangeSort={onChangeSort}
                                                    onSchemaChange={(schema) => {
                                                        this.setState({
                                                            schema: schema
                                                        })
                                                    }}
                                                />
                                                <div className="mobile-list-view">
                                                    <ListView
                                                        categories={categories}
                                                        members={members}
                                                        withLocation={true}
                                                        onClick={(member, index) => {
                                                            changeUrlForMember(member);
                                                            this.setState({
                                                                selectedMarker: {
                                                                    key: index,
                                                                    index,
                                                                    member
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                    }
                                </Fragment>
                        }


                    </div>
                </LoadScript>
            </Fragment>
        );
    }

}

export default Mobile;
